// extracted by mini-css-extract-plugin
export default {"info":"styles_info__ZywaD","icon":"styles_icon__t2TEZ","text":"styles_text__n9Ehm"};